/**
 * 从cookie中获取指定名称的值
 * @param name cookie的名称
 * @returns cookie的值或null
 */
function getCookieValue(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * 获取 _fbp 和 _fbc 的值
 * @returns 包含 _fbp 和 _fbc 的对象
 */
export function getFbpFbcFromCookie() {
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');

  return {
    ...(fbp && { fbp }),
    ...(fbc && { fbc }),
  };
}
